import { render, staticRenderFns } from "./VerifyPaymentModal.vue?vue&type=template&id=f835ff66&scoped=true"
import script from "./VerifyPaymentModal.vue?vue&type=script&lang=js"
export * from "./VerifyPaymentModal.vue?vue&type=script&lang=js"
import style0 from "./VerifyPaymentModal.vue?vue&type=style&index=0&id=f835ff66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f835ff66",
  null
  
)

export default component.exports